import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllTwitterSimilarInfluencers.graphql';
import { Query, QueryallTwitterSimilarInfluencersArgs } from '../../__generated__/globalTypes';

export const useAllTwitterSimilarInfluencersQuery = (
  options?: QueryHookOptions<Query, QueryallTwitterSimilarInfluencersArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallTwitterSimilarInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllTwitterSimilarInfluencersLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallTwitterSimilarInfluencersArgs>
): QueryResult<Query, QueryallTwitterSimilarInfluencersArgs> & {
  getAllTwitterSimilarInfluencers: LazyQueryExecFunction<Query, QueryallTwitterSimilarInfluencersArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllTwitterSimilarInfluencers, result] = useLazyQuery<Query, QueryallTwitterSimilarInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllTwitterSimilarInfluencers, ...result };
};

export const useAllTwitterSimilarInfluencersPromiseQuery = () => {
  const client = useApolloClient();

  const getAllTwitterSimilarInfluencers = useCallback(
    (options?: Omit<QueryOptions<QueryallTwitterSimilarInfluencersArgs, Query>, 'query'>) =>
      client.query<Query, QueryallTwitterSimilarInfluencersArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllTwitterSimilarInfluencers };
};
// Suspense Query Hooks
export const useAllTwitterSimilarInfluencersSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallTwitterSimilarInfluencersArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallTwitterSimilarInfluencersArgs>(QUERY, {
    ...options
  });

  return result;
};
